const satV1Zone = '/sat-v1-zone';

export const routes = {
  base: satV1Zone,
  uploadDataManagement: `${satV1Zone}/upload-data-management`,
  curriculumPlanning: `${satV1Zone}/curriculum-planning`,
  schoolStructureSetup: `${satV1Zone}/school-structure-setup`,
  teachersManagement: `${satV1Zone}/teachers-management`,
  timetableRulesPreferences: `${satV1Zone}/timetable-rules-preferences`,
  timetableGenerationManagement: `${satV1Zone}/timetable-generation-management`,
  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-v1-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    // Remove the baseName portion
    relative = absolutePath.substring(baseName.length);
  }

  // If there's a leading '/', strip it out so the returned path doesn't start with '/'
  return relative.startsWith('/') ? relative.substring(1) : relative;
}
